import { getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';
import { useSnapshot } from 'valtio';
import Table from '~/components2/Table';
import store from '../../store';
import AddAccess from './AddAccess';
import { columns } from './columns';

export default function Digitization() {
  const { agency } = useSnapshot(store) as typeof store;

  const data = useMemo(() => {
    return Object.values(agency?.digitization || []);
  }, [agency?.digitization]);

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    enableSorting: true,
    enableColumnResizing: true,
    columnResizeMode: 'onChange',
    getRowId: (row) => row.id,
  });

  return (
    <div className="flex h-full w-full flex-col space-y-4 overflow-y-clip">
      <div>
        <AddAccess />
      </div>

      <div className="grow overflow-y-auto">
        {isEmpty(data) ? (
          <div>Currently no digitization access for this agency.</div>
        ) : (
          <Table id="digitizationTable" table={table} />
        )}
      </div>
    </div>
  );
}
